// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"contact_flexContainer__Y_azZ","cardContainer":"contact_cardContainer__c_6Wh"};